import * as i0 from "@angular/core";
var VersionService = /** @class */ (function () {
    function VersionService() {
        this.versionNumber = "v20230609";
    }
    VersionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function VersionService_Factory() { return new VersionService(); }, token: VersionService, providedIn: "root" });
    return VersionService;
}());
export { VersionService };
